import { useLocalStorage } from 'utils';

export const useThemeMode = () => {
  const systemMode =
    window.matchMedia &&
    window.matchMedia('(prefers-color-scheme: dark)').matches
      ? 'dark'
      : 'light';

  const [theme, setTheme] = useLocalStorage('themeMode', systemMode);

  return [theme, setTheme];
};
